import request from '@/utils/request'

export function fetchAiTrusteeAdminOverview (params) {
  return request({
    url: '/coffee/leo/knowledge/ai-trustee-admin/overview',
    method: 'get',
    params
  })
}

export function saveAiTrusteeAdminGlobal (params, data) {
  return request({
    url: '/coffee/leo/knowledge/ai-trustee-admin/global',
    method: 'put',
    params,
    data
  })
}

export function saveAiTrusteeAdminStep (params, data) {
  const stepId = params && params.stepId
  return request({
    url: `/coffee/leo/knowledge/ai-trustee-admin/step/${encodeURIComponent(stepId)}`,
    method: 'put',
    params: { deviceFamily: params.deviceFamily },
    data
  })
}

export function saveAiTrusteeAdminCoach (params, data) {
  return request({
    url: '/coffee/leo/knowledge/ai-trustee-admin/coach',
    method: 'put',
    params,
    data
  })
}

export function saveAiTrusteeAdminRelease (params, data) {
  return request({
    url: '/coffee/leo/knowledge/ai-trustee-admin/release',
    method: 'put',
    params,
    data
  })
}

export function saveAiTrusteeAdminAutoClearStuck (params, data) {
  return request({
    url: '/coffee/leo/knowledge/ai-trustee-admin/settings/auto-clear-stuck',
    method: 'put',
    params,
    data
  })
}

/** 側欄 AI 狀態小圓點（綠／黃／紅／灰） */
export function fetchAiTrusteeSidebarStatus (params) {
  return request({
    url: '/coffee/leo/knowledge/ai-trustee-admin/sidebar-status',
    method: 'get',
    params,
    xrrossSkipBusinessErrorToast: true
  })
}



// WEBPACK FOOTER //
// ./src/api/leoAiTrusteeAdmin.js